export var Config = {
  env: Object.assign({}, process.env)
};